import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from '@env/environment';
import { add } from '@functions';
import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';

// Incrementar SESSION_VERSION en cada deploy con cambios incompatibles de sesión/auth
const SESSION_VERSION = 'v2';
const SESSION_VERSION_KEY = 'msc_session_version';

function clearLegacySession(): void {
    if (localStorage.getItem(SESSION_VERSION_KEY) === SESSION_VERSION) {
        return;
    }

    sessionStorage.clear();

    const preserve: Record<string, string | null> = {
        ssoKey: localStorage.getItem('ssoKey'),
        force_access: localStorage.getItem('force_access')
    };
    localStorage.clear();
    Object.entries(preserve).forEach(([k, v]) => {
        if (v !== null) { localStorage.setItem(k, v); }
    });
    localStorage.setItem(SESSION_VERSION_KEY, SESSION_VERSION);

    const cookiesToClear = ['token_msc', 'refresh_token', 'current_company'];
    const hostname = location.hostname;
    const rootDomain = hostname.split('.').length > 1
        ? hostname.split('.').slice(-2).join('.')
        : hostname;
    const domains = [hostname, `.${hostname}`, `.${rootDomain}`];

    cookiesToClear.forEach(name => {
        domains.forEach(domain => {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain};`;
        });
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
    });
}

clearLegacySession();

if (environment.production) {
    enableProdMode();
    window.console.log = () => { };
    window.console.table = () => { };
}

if (!(environment as any).local && Sentry) {
    Sentry.init({
        dsn: 'https://b9aa3dc464364078b9cdb514bc882fbb@o479680.ingest.sentry.io/5543726',
        integrations: [
            new Integrations.BrowserTracing({
                tracingOrigins: ['*.myskillcamp.com'],
                routingInstrumentation: Sentry.routingInstrumentation
            })
        ],
        tracesSampleRate: 1.0,
        environment: environment.production ? 'production' : 'development',
        ignoreErrors: [
            'Error: Cannot match any routes',
            'Handled unknown error',
            'Non-Error exception captured with keys',
            'ResizeObserver loop',
            'Http failure response',
            'InvalidStateError',
            '"status":40',
            'Not found',
            // new filters
            'HttpErrorResponse',
            'NG0',
            'Server returned code'
        ],
        denyUrls: [
            /extensions\//i,
            /^chrome:\/\//i
        ],
        release: '4.6.0'
    });
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
/*
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err))
  .then(() => {
    const fallbackImage = '/assets/images/imagen-rota.png';

    function applyHandler(img: HTMLImageElement) {
      img.addEventListener('error', function () {
        if (this.src !== fallbackImage) {
          this.src = fallbackImage;
        }
      });
    }

    // Inicial: las ya existentes
    document.querySelectorAll('img').forEach(applyHandler);

    // Observer: para futuras imágenes agregadas
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeName === 'IMG') {
            applyHandler(node as HTMLImageElement);
          } else if (node instanceof HTMLElement) {
            node.querySelectorAll('img').forEach(applyHandler);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
*/
